export default __webpack_public_path__ + "static/xy-histogram-with-mean-aggregation-578b753ff8c653dd40ee7a07e50547ae.png";